import { Card, CardActionsProps, CardContent, Grow, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Trainee } from '../../generated';

export const TraineeCard = (props: { trainee: Trainee; children?: ReactElement<CardActionsProps>; timeout: number }) => {
  const { children } = props;

  return (
    <Grow in={true} timeout={props.timeout}>
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} className="h-100">
        <CardContent sx={{ flex: 0.9 }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {props.trainee?.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.trainee.userId}
          </Typography>
        </CardContent>
        {children}
      </Card>
    </Grow>
  );
};
